import React, { ReactElement, useContext } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Login } from '../Auth/Login';
import { Auth } from '../Auth';
import { AuthFooterEnum } from '../Auth/Auth.view';
import { Invite } from '../Auth/Invite';
import { ForgotPassword } from '../Auth/ForgotPassword';
import { SwitchOrganization } from '../Auth/SwitchOrganization';
import { Toast } from 'primereact/toast';
import { Loader } from '../../components/containers/Loader';
import { AnonymousRoute, UserProtectedRoute, ResetPasswordRoute } from './Routes';
import { SessionToast } from './SessionToast';
import { AppContext, isFromChromeExtension } from '../../providers/AppProvider';
import { UserRootPage } from './UserRootPage';
import { Signup } from '../Auth/Signup';
import { FullPageLoader } from '../../components/containers/Loader/Loader.view';
import { Privacy } from '../Policy/Privacy';
import { TermsOfService } from '../Policy/TermsOfService';
import { useAuth } from '../../hooks/useAuth';
import { toastRef } from '../../helpers/showToast';
import { PostEditorPage } from './PostEditorPage';
import scssVars from '../../assets/scss/exportedVars.module.scss';
import { AutomaticLoginWrapper } from '../Auth/Login/AutomaticLoginWrapper';

export type AppViewProps = {
  loadingUserData: boolean;
};

export const AppView = (props: AppViewProps): ReactElement | null => {
  const { isLoggedIn } = useAuth();
  const { loadingOverlayVisible } = useContext(AppContext);

  if (props.loadingUserData) {
    return <FullPageLoader />;
  }

  return (
    <>
      <Routes>
        <Route
          path={'/login'}
          element={
            <AnonymousRoute>
              <AutomaticLoginWrapper>
                <Auth footer={AuthFooterEnum.login}>
                  <Login />
                </Auth>
              </AutomaticLoginWrapper>
            </AnonymousRoute>
          }
        />
        <Route
          path={'/signup'}
          element={
            <AnonymousRoute>
              <Auth footer={AuthFooterEnum.signup}>
                <Signup />
              </Auth>
            </AnonymousRoute>
          }
        />
        <Route
          path={'/forgot-password'}
          element={
            <AnonymousRoute>
              <Auth footer={AuthFooterEnum.backToLogin}>
                <ForgotPassword />
              </Auth>
            </AnonymousRoute>
          }
        />
        <Route
          path={'/reset-password/:token'}
          element={
            <AnonymousRoute>
              <ResetPasswordRoute />
            </AnonymousRoute>
          }
        />
        <Route path={'/invite/:token'} element={<Invite />} />
        <Route
          path={'/change-org'}
          element={
            <UserProtectedRoute>
              <Auth>
                <SwitchOrganization />
              </Auth>
            </UserProtectedRoute>
          }
        />
        {!isLoggedIn && <Route path={'/terms'} element={<TermsOfService />} />}
        {!isLoggedIn && <Route path={'/privacy'} element={<Privacy />} />}
        {!isLoggedIn && isFromChromeExtension && <Route path={'/post-editor'} element={<PostEditorPage />} />}
        <Route
          path={'/*'}
          element={
            <UserProtectedRoute>
              <UserRootPage />
            </UserProtectedRoute>
          }
        />
      </Routes>
      {loadingOverlayVisible && <Loader variation={'dark'} size={'large'} type={'overlay'} />}
      <SessionToast>
        <Toast ref={toastRef} baseZIndex={+scssVars['z-index-toaster'] - 1000} />
      </SessionToast>
      {/* Base toaster Z-index starts from 1000. Our zindex map toaster value is 5000. Baze zindex + 4000 = desired z-index value*/}
    </>
  );
};
